import React, { useState } from 'react';
import Modal from '../shared/Modal';
import { moldLabelService } from '../../services/api';

interface MoldLabelModalProps {
  onClose: () => void;
  selectedMoldIds: number[];
}

const MoldLabelModal: React.FC<MoldLabelModalProps> = ({ onClose, selectedMoldIds }) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleDownload = async () => {
    setIsLoading(true);
    try {
      const response = await moldLabelService.downloadMoldLabels({moldIds: selectedMoldIds});
      const blob = new Blob([response.data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      window.open(url, '_blank');
    } catch (error) {
      console.error('Error downloading labels:', error);
    } finally {
      setIsLoading(false);
      onClose();
    }
  };

  return (
    <Modal 
      onClose={onClose}
      isBackgroundTransparent={true}
      hideTopPadding={true}
    >
      <div className="px-4 pb-4">
        <h2 className="text-lg font-semibold">ดาวน์โหลดป้ายแม่พิมพ์</h2>
        <p>
          {selectedMoldIds.length > 0
            ? `ดาวน์โหลดป้ายสำหรับแม่พิมพ์ที่เลือก ${selectedMoldIds.length} รายการ`
            : 'ไม่ได้เลือกแม่พิมพ์ ดาวน์โหลดป้ายสำหรับแม่พิมพ์ทั้งหมด'}
        </p>
        <div className="mt-4 flex justify-end">
          <button
            onClick={onClose}
            className="mr-2 bg-gray-300 text-black px-4 py-2 rounded hover:bg-gray-400"
            disabled={isLoading}
          >
            ยกเลิก
          </button>
          <button
            onClick={handleDownload}
            className={`bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 ${isLoading ? 'opacity-50 cursor-not-allowed' : ''}`}
            disabled={isLoading}
          >
            {isLoading ? 'กำลังดาวน์โหลด...' : 'ดาวน์โหลด'}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default MoldLabelModal;